<section class="navigation-logo">
  <wchfs-icon *ngIf="!isPng" [size]="size" [svgIcon]="path" class="logo logo-svg fx-flex-35"></wchfs-icon>
  <img *ngIf="isPng" [src]="path" class="logo logo-png" />
</section>
